module.exports = __webpack_public_path__ + "img/table.c8aeb0bf.svg";